// @flow
import React from 'react'
import Link from "gatsby-link"
import injectSheet from "react-jss"
import classNames from 'classnames'

import {styles} from './Styles/FeatureSection.Style'

import Edit from '../images/Edit.png'
import Export from '../images/Export.png'
import Variant from '../images/Variant.png'

type Props = {
  classes: { [string]: string }
}

class FeatureSection extends React.Component {
  props: Props

    render () {
      const {classes} = this.props

      return (
        <div className={classNames(classes.conatainer, 'container wrap')}>
          <div className='row'>
            <div className={classNames(classes.section, classes.padding, 'col-sm-4 col-xs-12')}>
              <img src={Edit} alt='Edit' width='110' />
              <h3>Edit your collection</h3>
              <p>
                Create, edit and add notes to your collection. All products are
                securely saved and accessible across your team.
              </p>
            </div>
            <div className={classNames(classes.section, classes.padding, 'col-sm-4 col-xs-12')}>
              <img src={Variant} alt='Variant' width='110' />
              <h3>Generate variants</h3>
              <p>
                Generate all your variants in seconds. Change sizes, stones,
                metals, anything you want. Partsee creates the SKUs for you.
              </p>
            </div>
            <div className={classNames(classes.section, classes.padding, 'col-sm-4 col-xs-12')}>
              <img src={Export} alt='Export' width='110' />
              <h3>Sync products to Shopify</h3>
              <p>
                Add your Shopify account to keep all your products synced.
                Partsee will make sure your products information stay
                consistent.
              </p>
            </div>
          </div>
        </div>
      )
    }
}

export default injectSheet(styles)(FeatureSection)



// WEBPACK FOOTER //
// ./src/layouts/FeatureSection.jsx